import { CountyDTO, UfDTO } from '@/store/graphql/queries/westerosAdmissionsQueries';

export interface IdentificationDocument {
  rg?: string;
  issuer?: string;
  issueDate?: string;
  issueState?: string;
  motherName?: string;
  fatherName?: string;
}

export interface IdentificationDocumentFinancialSponsor {
  rg?: string;
  issuer?: string;
  issueDate?: string;
  issueState?: string;
}

export interface PersonalData {
  cpf?: string;
  race?: string;
  email?: string;
  phone?: string;
  gender?: string;
  fullName?: string;
  birthDate?: string;
  nationality?: string;
  placeOfBirth?: string;
  householdIncome?: string;
  cityBirth?: string;
}

export interface PersonalDataFinancialSponsor {
  cpf?: string;
  email?: string;
  phone?: string;
  fullName?: string;
  birthDate?: string;
}

export interface AcademicFormation {
  schoolCategory?: string;
  year?: number;
  city?: string;
}

export interface AddressInfo {
  zipCode?: string;
  neighborhood?: string;
  street?: string;
  number?: string;
  complement?: string;
  state?: string;
  city?: string;
}

export interface SponsorAddressInfo {
  sponsorZipCode?: string;
  sponsorNeighborhood?: string;
  sponsorStreet?: string;
  sponsorNumber?: string;
  sponsorComplement?: string;
  sponsorState?: string;
  sponsorCity?: string;
}

export interface StudentDataState {
  personalData?: PersonalData;
  academicFormation?: AcademicFormation;
  personalDataFinancialSponsor?: PersonalDataFinancialSponsor;
  identificationDocument?: IdentificationDocument;
  identificationDocumentFinancialSponsor?: IdentificationDocumentFinancialSponsor;
  raceOptions?: string[];
  genderOptions?: string[];
  nationalityOptions?: string[];
  placeOfBirthOptions: Record<string, UfDTO>;
  householdIncomeOptions?: string[];
  statesOptions?: string[];
  issuerOptions?: string[];
  addressInfo?: AddressInfo;
  sponsorAddressInfo?: SponsorAddressInfo;
  issueStateOptions?: string[];
  signupMethod?: string;
  countys: Record<string, CountyDTO>;
  notInformed: string;
  loadingCountysOptions?: boolean;
}

const studentData: StudentDataState = {
  personalData: undefined,
  academicFormation: undefined,
  personalDataFinancialSponsor: undefined,
  addressInfo: undefined,
  sponsorAddressInfo: undefined,
  identificationDocument: undefined,
  identificationDocumentFinancialSponsor: undefined,
  raceOptions: undefined,
  genderOptions: undefined,
  nationalityOptions: undefined,
  placeOfBirthOptions: {
    'NÃO INFORMADO': {
      uf: '00',
      name: 'NÃO INFORMADO',
    },
    ACRE: {
      uf: 'AC',
      name: 'ACRE',
    },
    ALAGOAS: {
      uf: 'AL',
      name: 'ALAGOAS',
    },
    AMAZONAS: {
      uf: 'AM',
      name: 'AMAZONAS',
    },
    AMAPA: {
      uf: 'AP',
      name: 'AMAPA',
    },
    BAHIA: {
      uf: 'BA',
      name: 'BAHIA',
    },
    CEARA: {
      uf: 'CE',
      name: 'CEARA',
    },
    'DISTRITO FEDERAL': {
      uf: 'DF',
      name: 'DISTRITO FEDERAL',
    },
    'ESPIRITO SANTO': {
      uf: 'ES',
      name: 'ESPIRITO SANTO',
    },
    GOIAS: {
      uf: 'GO',
      name: 'GOIAS',
    },
    MARANHAO: {
      uf: 'MA',
      name: 'MARANHAO',
    },
    'MINAS GERAIS': {
      uf: 'MG',
      name: 'MINAS GERAIS',
    },
    'MATO GROSSO DO SUL': {
      uf: 'MS',
      name: 'MATO GROSSO DO SUL',
    },
    'MATO GROSSO': {
      uf: 'MT',
      name: 'MATO GROSSO',
    },
    PARA: {
      uf: 'PA',
      name: 'PARA',
    },
    PARAIBA: {
      uf: 'PB',
      name: 'PARAIBA',
    },
    PERNAMBUCO: {
      uf: 'PE',
      name: 'PERNAMBUCO',
    },
    PIAUI: {
      uf: 'PI',
      name: 'PIAUI',
    },
    PARANA: {
      uf: 'PR',
      name: 'PARANA',
    },
    'RIO DE JANEIRO': {
      uf: 'RJ',
      name: 'RIO DE JANEIRO',
    },
    'RIO GRANDE DO NORTE': {
      uf: 'RN',
      name: 'RIO GRANDE DO NORTE',
    },
    RONDONIA: {
      uf: 'RO',
      name: 'RONDONIA',
    },
    RORAIMA: {
      uf: 'RR',
      name: 'RORAIMA',
    },
    'RIO GRANDE DO SUL': {
      uf: 'RS',
      name: 'RIO GRANDE DO SUL',
    },
    'SANTA CATARINA': {
      uf: 'SC',
      name: 'SANTA CATARINA',
    },
    SERGIPE: {
      uf: 'SE',
      name: 'SERGIPE',
    },
    'SAO PAULO': {
      uf: 'SP',
      name: 'SAO PAULO',
    },
    TOCANTINS: {
      uf: 'TO',
      name: 'TOCANTINS',
    },
  },
  householdIncomeOptions: undefined,
  statesOptions: undefined,
  issuerOptions: undefined,
  issueStateOptions: undefined,
  signupMethod: undefined,
  countys: {},
  notInformed: 'NÃO INFORMADO',
  loadingCountysOptions: false,
};

export default studentData;
